/*@ngInject*/
const reviewPolicyRewriteLocale = require('../reviewPolicyRewrite/reviewPolicyRewrite.i18n.json');

const PolicyRewriteActionUtil = function ($rootScope, $uibModal, appTypeConfigurationModel, coreConstant, submissionConstant,
                                        uiPerformanceLoggerConstant, loadingBarHandler, modalUtil, umModalUtil, policyRewriteActionsMediator, coreMediator)  {

    this.i18n = {
        reviewPolicyRewrite: reviewPolicyRewriteLocale
    };

    this.reviewChanges = function (policyRewriteId, isReissue) {
        const context = isReissue ? 'policyReissue' : 'policyRewrite';
        policyRewriteActionsMediator.getPolicyRewriteSummary(policyRewriteId).then((policyRewriteSummary) => {
            $uibModal.open({
                templateUrl: '/modification/reviewChanges/reviewChangesModal.tpl.html',
                controller: 'reviewChangesModalController',
                backdrop: 'static',
                windowClass: 'reviewChangesModal',
                resolve: {
                    options: () => {
                        return {
                            title: _.get(this.i18n, `reviewPolicyRewrite.${context}.reviewChangesTitle`),
                            isReadOnly: false,
                            continueButtonLabel: _.get(this.i18n, `reviewPolicyRewrite.${context}.reviewClose`),
                            changeSetId: policyRewriteSummary.changeSetId,
                            showCancel: false,
                            entityId: policyRewriteId
                        };
                    }
                }
            });
        });
    };

    this.createPolicyRewrite = function (policyRewriteId, isReissue) {
        const context = isReissue ? 'policyReissue' : 'policyRewrite';
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_POLICY_REWRITE, `PolicyRewrite: ${policyRewriteId}`);
        loadingBarHandler.showLoadingBar(`submission.${context}.creatingPolicyRewriteLoadingBar`);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        const onSuccess = () => {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_POLICY_REWRITE, coreConstant.uiPeformanceLogger.SUCCESS);
        };

        const onFailure = () => {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_POLICY_REWRITE, coreConstant.uiPeformanceLogger.FAIL);
        };

        const promise = policyRewriteActionsMediator.create(policyRewriteId).then(onSuccess, onFailure);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.deletePolicyRewrite = function (policyRewriteId, submissionId, isReissue) {
        const context = isReissue ? 'PolicyReissue' : 'PolicyRewrite';
        function handleClose() {
            let promise = policyRewriteActionsMediator.delete(policyRewriteId).finally(function () {
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW);
                loadingBarHandler.hideLoadingBar();
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }

        modalUtil.showConfirmationModal(
            submissionId,
            null/*quoteId*/,
            null/*notificationName*/,
            `submission.wizard.delete${context}`,
            uiPerformanceLoggerConstant.DELETE_POLICY_REWRITE,
            /*hideLoadingBar*/false,
            handleClose);
    };

    this.submitPolicyRewrite = function (policyRewriteId, isReissue) {
        const context = isReissue ? 'policyReissue' : 'policyRewrite';
        policyRewriteActionsMediator.getPolicyRewriteSummary(policyRewriteId).then((policyRewriteSummary) => {

            if(!_.isNil(policyRewriteSummary.changeSetId)) {
                const modalInstance = $uibModal.open({
                    templateUrl: '/modification/reviewChanges/reviewChangesModal.tpl.html',
                    controller: 'reviewChangesModalController',
                    backdrop: 'static',
                    windowClass: 'reviewChangesModal',
                    resolve: {
                        options: () => {
                            return {
                                title: _.get(this.i18n, `reviewPolicyRewrite.${context}.reviewSubmitTitle`),
                                isReadOnly: false,
                                continueButtonLabel: _.get(this.i18n, `reviewPolicyRewrite.${context}.submitChanges`),
                                changeSetId: policyRewriteSummary.changeSetId,
                                showCancel: true,
                                entityId: policyRewriteId,
                                showMessage: appTypeConfigurationModel.isUnderwriterWorkstation()
                            };
                        }
                    }
                });

                modalInstance.result.then(() => {
                    loadingBarHandler.showLoadingBar(`submission.${context}.submittingPolicyRewriteLoadingBar`);
                    let promise = policyRewriteActionsMediator.submit(policyRewriteId).finally(function () {
                        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                        loadingBarHandler.hideLoadingBar();
                    });
                    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                    return promise;
                });
            } else {
                loadingBarHandler.showLoadingBar(_.get(this.i18n, `reviewPolicyRewrite.${context}.loadingBar`));
                let promise = policyRewriteActionsMediator.submit(policyRewriteId).finally(function () {
                    $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                    loadingBarHandler.hideLoadingBar();
                });
                $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                return promise;
            }
        });
    };


    this.startRating = function (policyRewriteId, isReissue) {
        const context = isReissue ? 'policyReissue' : 'policyRewrite';
        loadingBarHandler.showLoadingBar(`submission.${context}.startRating`);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        const promise = policyRewriteActionsMediator.startRating(policyRewriteId).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.refreshQuote = function (policyRewriteId, isReissue) {
        const context = isReissue ? 'policyReissue' : 'policyRewrite';
        loadingBarHandler.showLoadingBar(`submission.${context}.refreshQuote`);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        const promise = policyRewriteActionsMediator.refreshQuote(policyRewriteId).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.generateRating = function (policyRewriteId) {
        loadingBarHandler.showLoadingBar('submission.ratingEngineProcessing');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        const promise = policyRewriteActionsMediator.generateRating(policyRewriteId).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.generateRatingAttachments = function (policyRewriteId, submissionId) {
        const dynamicDataSetParams = {
                name: 'Rating Attachment Groups',
                submissionUri: `com.firstbest.underwriting.submission.Submission:${submissionId}`,
                ownerUri: `com.firstbest.underwriting.policy.rewrite.PolicyRewrite:${policyRewriteId}`
            };

        function onSuccess(response) {
            let ratingAttachmentGroups = {};

            // Format the response into a mapping of the separate attachment groups, for easier processing in the modal.
            _.each(response, function (dataItem) {
                if (!ratingAttachmentGroups[dataItem.grouping]) {
                    ratingAttachmentGroups[dataItem.grouping] = {
                        name: dataItem.grouping,
                        ratingAttachments: []
                    };
                }

                ratingAttachmentGroups[dataItem.grouping].ratingAttachments.push(dataItem);
            });

            $uibModal.open({
                templateUrl: '/wizard/generateRatingAttachments/generateRatingAttachmentsModal.tpl.html',
                controller: 'generateRatingAttachmentsModalController',
                windowClass: 'generateRatingAttachmentsModalContainer',
                backdrop: 'static',
                resolve: {
                    options: function () {
                        return {
                            ratingAttachmentGroups: ratingAttachmentGroups
                        };
                    }
                }
            }).result.then(function (options) {
                const action = uiPerformanceLoggerConstant.GENERATE_RATING_ATTACHMENTS,
                    message = policyRewriteId.toString();

                function onSuccess() {
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.SUCCESS);
                }

                function onError() {
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.FAIL);
                }

                function onFinally() {
                    $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                    loadingBarHandler.hideLoadingBar();
                }

                loadingBarHandler.showLoadingBar('submission.wizard.generateRatingAttachments.loadingBar');
                $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
                $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

                const promise = policyRewriteActionsMediator.generateRatingAttachments(policyRewriteId, options.selectedRatingAttachments).then(onSuccess, onError).finally(onFinally);
                $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                return promise;
            });
        }

        coreMediator.getDynamicDataSetItems(dynamicDataSetParams).then(onSuccess);
    };

    this.startPricing = function (policyRewriteId) {
        loadingBarHandler.showLoadingBar('submission.startPricing');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        const promise = policyRewriteActionsMediator.startPricing(policyRewriteId).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.modifyPricing = function (policyRewriteId) {
        loadingBarHandler.showLoadingBar('submission.modifyPricing');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        const promise = policyRewriteActionsMediator.modifyPricing(policyRewriteId).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.modifyRating = function (policyRewriteId) {
        loadingBarHandler.showLoadingBar('submission.modifyingRating');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        const promise = policyRewriteActionsMediator.modifyRating(policyRewriteId).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };


    this.submitPolicyRewriteForIssuance = function (policyRewriteId, isReissue) {
        const context = isReissue ? 'policyReissue' : 'policyRewrite';
        loadingBarHandler.showLoadingBar(`submission.${context}.submittingPolicyRewriteForIssuanceLoadingBar`);
        const promise = policyRewriteActionsMediator.submitForIssuance(policyRewriteId).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.markPolicyRewriteAsIssued = function (policyRewriteId, submissionId, isReissue) {
        const context = isReissue ? 'PolicyReissue' : 'PolicyRewrite';
        function handleClose() {
            const promise = policyRewriteActionsMediator.markIssued(policyRewriteId).finally(function () {
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                loadingBarHandler.hideLoadingBar();
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }

        modalUtil.showConfirmationModal(
            submissionId,
            null/*quoteId*/,
            null/*notificationName*/,
            `submission.wizard.mark${context}AsIssued`,
            uiPerformanceLoggerConstant.MARK_POLICY_REWRITE_AS_ISSUED,
            /*hideLoadingBar*/false,
            handleClose);
    };

    this.revertPolicyRewriteToSubmitted = function (policyRewriteId, isReissue) {
        const context = isReissue ? 'policyReissue' : 'policyRewrite';
        loadingBarHandler.showLoadingBar(`submission.${context}.revertingPolicyRewriteToSubmittedLoadingBar`);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        const promise = policyRewriteActionsMediator.revertToSubmitted(policyRewriteId).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

};

angular.module('gw-um-submission')
    .service('policyRewriteActionUtil', PolicyRewriteActionUtil);
